import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Chat from "../components/Chat";
import { DataContext } from "../context/DataContext";

import estilo from "./styles/ChatUsuario.module.css";

function ChatUsuario() {
  const params = useParams();

  let navigate = useNavigate();

  const { usuario } = useContext(DataContext);

  useEffect(() => {
    if (usuario === null) {
      navigate("/");
    }
    if (params) {
    }
  }, []);

  console.log(params.id.length);
  return (
    <div className={estilo.chat_usuario}>
      <Chat receptor={params.id}></Chat>
    </div>
  );
}

export default ChatUsuario;
